import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import R from "ramda";
import { addDays, format } from "date-fns";
import { breakpoint } from "../../breakpoint";
import DateSpan from "../components/DateSpan.jsx";
import YearSpan from "../components/YearSpan.jsx";
import QueryField from "../components/QueryField.jsx";
import TypeaheadFacet from "../components/TypeaheadFacet.jsx";
import CheckboxFacet from "../components/CheckboxFacet.jsx";

export default class FacetList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentBreakpoint: breakpoint(),
      facetsOpen: breakpoint().indexOf("small") === -1
    };
  }

  handleSearchInteraction = () => {
    let searchListing = document.querySelector('.search-listing'),
        publicationListing = document.querySelector('.publication-listing'),
        article = document.querySelector('.article-body'),
        featured = document.querySelector('.top-accent.featured');

    if (searchListing) {
      if (!searchListing.classList.contains('show-results')) {
        searchListing.classList.add('show-results');
      }
    }

    if (publicationListing) {
      if (!publicationListing.classList.contains('hide-results')) {
        publicationListing.classList.add('hide-results');
      }
    }

    if (article) {
      if (!article.classList.contains('hide-article')) {
        article.classList.add('hide-article');
      }
    }

    if (featured) {
      document.querySelector('.top-accent.featured').classList.remove('featured');
    }
  }

  componentDidMount = () => {
   // window.addEventListener("resize", this.updateBreakpoint);
  }

  componentWillUnmount = () => {
    // window.removeEventListener("resize", this.updateBreakpoint);
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.facetsOpen == this.state.facetsOpen) {
      this.handleSearchInteraction();
    }
  }

  // updateBreakpoint = () => {
  //   this.setState({
  //     currentBreakpoint: breakpoint()
  //   });
  // }

  openFacets = () => {
    this.setState({
      facetsOpen: true
    });
  }

  handleFacetChange = (changedFacet, toAdd) => {
    const { handleUpdate, selectedFacets } = this.props;

    const starterFacets = selectedFacets ? selectedFacets : [];

    if (toAdd) {
      handleUpdate({ page: 1, facet: changedFacet });
    } else {
      handleUpdate({
        page: 1,
        facet: starterFacets.filter(facet => facet !== changedFacet) || []
      });
    }

    // this.handleSearchInteraction();
  }

  formatDate(dateStr) {
    // not sure why we have to add a day here
    return format(addDays(new Date(dateStr), 1), "MMMM do, yyyy");
  }

  showClearFilter(dateFacetLabel, selectedFacetList, queryInfo) {
    let show = false;
    if (dateFacetLabel || selectedFacetList.length > 0 || queryInfo.q) {
      show = true;
    }

    return show;
  }

  showDateWidget = (dateType, dateInfo, handleUpdate) => {
    if (dateInfo == false) {
      return false;
    }
    if (dateType == 'year-picker') {
      return <YearSpan handleUpdate={handleUpdate} {...dateInfo} />;
    } else {
      return <DateSpan handleUpdate={handleUpdate} {...dateInfo} />;      
    }
  }

  showCheckbox = (checkboxLabel, checkboxType, handleUpdate) => {
    if (checkboxType) {
      return <CheckboxFacet checkboxType={checkboxType} handleUpdate={handleUpdate} checkboxLabel={checkboxLabel} />;
    }
  }

  handleClearFilterClick = () => {
    const { handleUpdate } = this.props;
    handleUpdate({
      page: 1,
      facet: [],
      endDate: null,
      startDate: null,
      q: ""
    });
  }

  render() {
    const {
      altClass,
      checkboxLabel,
      checkboxType,
      dateInfo,
      dateType,
      dictionary,
      facets,
      handleUpdate,
      horizontal,
      queryInfo,
      selectedFacets,
      selectedFacetsPosition
    } = this.props;
    const { facetsOpen } = this.state;

    const starterFacets = selectedFacets ? selectedFacets : [];

    const joinBySelected = R.innerJoin(R.flip(R.propEq("id")));
    const selectedFacetList = joinBySelected(
      R.flatten(R.map(facet => facet.values, facets)),
      starterFacets
    );

    const fieldsClass = classNames('facets__fields', { 'facets__fields--3-up': horizontal && !altClass }, { 'facets__fields--4-up': horizontal && altClass });

    const dateFacetLabel =
      dateInfo.endDate || dateInfo.startDate
        ? (dateInfo.startDate
          ? this.formatDate(dateInfo.startDate)
          : "Any time") +
        " - " +
        (dateInfo.endDate ? this.formatDate(dateInfo.endDate) : "Any time")
        : null;

    return (
      <div className="facets">
        {!facetsOpen && (
          <div className="mobile-search-note">Expand to search the archives.</div>
        )}
        <div className="facets__inner">
          {!facetsOpen && (
            <button
              className="btn btn--accordion"
              onClick={() => this.openFacets()}
            >
              {dictionary.facetsTitle}
            </button>
          )}
          {facetsOpen && (
            <div>
              <h2 className="facets__title">{dictionary.facetsTitle}</h2>
              {(this.showClearFilter(dateFacetLabel, selectedFacetList, queryInfo)) &&
                selectedFacetsPosition !== "bottom" && (
                  <div className="facets__controls">
                    <div className="facets__clear">
                        <button
                          className="btn btn--link facets__clear-btn"
                          onClick={this.handleClearFilterClick}
                        >
                          Clear Filters
                        </button>
                      </div>

                    <div className="facets__selected" aria-live="polite" aria-atomic="true">
                      <h3 className="facets__selected-title">
                        Selected Filters
                      </h3>
                      <ul className="facets__selected-list">
                        {selectedFacetList.map((facet, i) => (
                          <li key={i}>
                            <button
                              onClick={() =>
                                this.handleFacetChange(facet.id, false)
                              }
                              className="btn btn--secondary"
                            >
                              {facet.name}
                            </button>
                          </li>
                        ))}
                        {dateFacetLabel && (
                          <li key="datefacet">
                            <button
                              className="btn btn--secondary"
                              onClick={() =>
                                handleUpdate({ endDate: null, startDate: null })
                              }
                            >
                              {dateFacetLabel}
                            </button>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                )}
              <a
                href="#listing_jump_target"
                className="visually-hidden focusable skip-link"
              >
                Jump to results
              </a>
              <div className={fieldsClass}>
                {queryInfo && (
                  <div className="facets__input">
                    <QueryField
                      label={queryInfo.label}
                      id={queryInfo.id}
                      handleUpdate={queryInfo.handleUpdate}
                      q={queryInfo.q}
                    />
                  </div>
                )}
                {facets.length > 0 &&
                  facets.map((facet, i) => (
                    <TypeaheadFacet
                      key={i}
                      handleFacetChange={this.handleFacetChange}
                      selectedFacets={starterFacets}
                      {...facet}
                    />
                  )
                )}
                {this.showDateWidget(dateType, dateInfo, handleUpdate)}
                {this.showCheckbox(checkboxLabel, checkboxType, handleUpdate)}
              </div>
              {(this.showClearFilter(dateFacetLabel, selectedFacetList, queryInfo)) &&
                selectedFacetsPosition === "bottom" && (
                  <div className="facets__controls">
                    <div className="facets__selected" aria-live="polite" aria-atomic="true">
                      <h3 className="facets__selected-title">
                        Selected Filters
                      </h3>
                      <ul className="facets__selected-list">
                        {selectedFacetList.map((facet, i) => (
                          <li key={i}>
                            <button
                              onClick={() =>
                                this.handleFacetChange(facet.id, false)
                              }
                              className="btn btn--secondary"
                            >
                              {facet.name}
                            </button>
                          </li>
                        ))}
                        {dateFacetLabel && (
                          <li key="datefacet">
                            <button
                              className="btn btn--secondary"
                              onClick={() =>
                                handleUpdate({
                                  page: 1,
                                  endDate: null,
                                  startDate: null
                                })
                              }
                            >
                              {dateFacetLabel}
                            </button>
                          </li>
                        )}
                      </ul>
                    </div>
                    <div className="facets__clear">
                      <button
                        className="btn btn--link facets__clear-btn"
                        onClick={this.handleClearFilterClick}
                      >
                        Clear Filters
                      </button>
                    </div>
                  </div>
                )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const { array, bool, func, object, oneOfType, string } = PropTypes;

FacetList.propTypes = {
  altClass: bool,
  checkboxLabel: string,
  checkboxType: string,
  dateType: string,
  dateInfo: oneOfType([object, bool]),
  dictionary: object,
  facets: array,
  handleUpdate: func,
  horizontal: bool,
  queryInfo: object,
  selectedFacets: array,
  selectedFacetsPosition: string
};
